import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { ButtonModule } from 'primeng/button';
import { MenuItem } from 'primeng/api';
import { SplitButtonModule } from 'primeng/splitbutton';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { RouterModule } from '@angular/router';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-topbar',
  standalone:true,
  imports: [
    RouterModule,
    ButtonModule,
    SplitButtonModule
  ],
  templateUrl: './topbar.component.html',
  styles: ``
})
export class TopbarComponent implements OnInit, OnDestroy {
  title: string = "Olimpiako";
  userLinks: MenuItem[] = [];

  userAuthenticatedSubscription: Subscription;
  userAuthenticated: boolean = false;

  isDark: boolean = false;

  constructor(private layoutService: LayoutService,
    private authService: AuthService,
    private themeService: ThemeService) {

    this.userAuthenticatedSubscription = this.authService.loginChanged.subscribe(res => {
      if (res) {
        this.userAuthenticated = true;
        this.setUserLinks();
      }
    });
  }

  ngOnInit(): void {
    this.userAuthenticated = this.authService.isAuthenticated();
    this.setUserLinks();

    this.isDark = localStorage.getItem('theme') === 'dark';
    this.themeService.loadSaved();

  }

  ngOnDestroy() {
    if (this.userAuthenticatedSubscription) {
      this.userAuthenticatedSubscription.unsubscribe();
    }
  }

  private setUserLinks() {
    this.userLinks = [];

    if (this.userAuthenticated) {
      this.userLinks = [
        {
          label: 'Profilo',
          routerLink: '/currentuser'
        },
        { separator: true },
        {
          label: 'Esci',
          command: () => {
            this.logout();
          }
        },
      ];
    } else {
      this.userLinks = [
        {
          label: 'Accedi',
          command: () => {
            this.login();
          }
        },
      ];
    }
  }

  public login = () => {
    this.authService.login();
  }

  public logout = () => {
    this.authService.logout();
  }

  public toggleSideBar(): void {
    this.layoutService.onMenuToggle();
  }

  public changeTheme(): void {
    const current = localStorage.getItem('theme');
    if (current === 'dark') {
      this.themeService.setLight();
      this.isDark = false;
    } else {
      this.themeService.setDark();
      this.isDark = true;
    }
  }


}
